import { request } from './client.js';
/**
 * POST /valet/tickets/:ticketId/exits
 *
 * Registers a vehicle exit for a Hotel-niche ticket.
 * Enforces in/out policy (unlimited / max_exits / per_exit_fee).
 */
export async function registerTicketExit(ticketId, input = {}) {
    return request(`/valet/tickets/${encodeURIComponent(ticketId)}/exits`, {
        method: 'POST',
        body: input,
    });
}
/**
 * PATCH /valet/tickets/:ticketId/exits/latest/re-entry
 *
 * Closes the most-recent open TicketExit (sets reentryAt = now).
 * After this call the vehicle is back IN and delivery is unblocked.
 */
export async function registerTicketReentry(ticketId, input = {}) {
    return request(`/valet/tickets/${encodeURIComponent(ticketId)}/exits/latest/re-entry`, { method: 'PATCH', body: input });
}
//# sourceMappingURL=ticket-exits.js.map